<script setup lang="ts">
// ================================
// IMPORTS
// ================================
</script>

<template>
    <!-- ================================ -->
    <!-- PAGE CONTAINER -->
    <!-- ================================ -->
    <div class="page page-login flex justify-center items-center min-h-screen">
        <div class="w-full max-w-2xl mx-4">
            <FormAuthUpdatePassword class="p-8" />
        </div>
    </div>
</template>
